<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qYHFbI/tc-custom/9780253053787.jpg?1731166637860" alt="This image is the cover for the book Thomas Sankara"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Thomas Sankara
      </h1>
      <p class="bookDescription body article font2">
        <p><i>Thomas Sankara: A Revolutionary in Cold War Africa</i> offers the first complete biography in English of the dynamic revolutionary leader from Burkina Faso, Thomas Sankara. Coming to power in 1983, Sankara set his sights on combating social injustice, poverty, and corruption in his country, fighting for women's rights, direct forms of democracy, economic sovereignty, and environmental justice. </p><p>Drawing on government archival sources and over a hundred interviews with Sankara's family members, friends, and closest revolutionary colleagues, Brian J. Peterson details Sankara's political career and rise to power, as well as his assassination at age 37 in 1987, in a plot led by his close friend Blaise Compaoré. </p><p><i>Thomas Sankara: A Revolutionary in Cold War</i> Africa offers a unique, critical appraisal of Sankara and explores why he generated such enthusiasm and hope in Burkina Faso and beyond, why he was such a polarizing figure, how his rivals seized power from him, and why T-shirts sporting his image still appear on the streets today.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brian J. Peterson
      </h2>
      
      <p class="authorDescription body article"><P>Brian J. Peterson is Associate Professor of History and Director of the Africana Studies Program at Union College. He is author of <I>Islamization from Below: The Making of Muslim Communities in Rural French Sudan, 1880–1960</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?67a6d772